import { AxiosResponse } from "axios";
import { Favorite } from "onnit-ui/lib/@types/interfaces/favorites/Favorite";
import { PaginatedResponse } from "onnit-ui/lib/@types/interfaces/PaginatedResponse";
import config from "../config";
import AbstractClient from "./AbstractClient";

export default class FavoritesClient extends AbstractClient {
    protected getBaseUrl(): string {
        return config.API_URL;
    }

    async list(customerId: number, page = 1, perPage = 10): Promise<PaginatedResponse<Favorite>> {
        const resp = await this.axios.get(`/customers/${customerId}/favorites?per_page=${perPage}&page=${page}`);
        return resp.data;
    }

    async create(customerId: number, productId: number): Promise<AxiosResponse<Favorite>> {
        const url = `/customers/${customerId}/favorites`;
        return this.axios.post(url, { product_id: productId });
    }

    destroy(customerId: number, favoriteId: number): Promise<AxiosResponse<void>> {
        return this.axios.delete(`/customers/${customerId}/favorites/${favoriteId}`);
    }

    protected withCredentials(): boolean {
        // These requests REQUIRE a valid authentication token cookie.
        return true;
    }
}
